import { render, staticRenderFns } from "./ContractorList.vue?vue&type=template&id=479d388a&"
import script from "./ContractorList.vue?vue&type=script&lang=js&"
export * from "./ContractorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports